import { Outlet } from "react-router-dom";
import Navbar from "../components/Navebar";
import Footer from "../components/Footer";
import HeaderBanner from "../components/Header";
import Info from "../components/Info";
export default function Layout() {
  return (
    <>
      <HeaderBanner />
      <Info />
      <Navbar />

      <div style={{ padding: "0px", backgroundColor: "#f4f7fc" }}>
        <Outlet />
      </div>

      <Footer />
    </>
  );
}
